import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { handleResponse } from 'APIPackage/MainModule/common/handleResponse';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { IPaginationParams } from 'APIPackage/MainModule/interfaces/IPaginationParams';
import { createPaginationParams } from 'APIPackage/MainModule/common/createPaginationParams';

import { IManageTestUsersResponse } from '../interface/IManageTestUsersResponse';
import { IActionAboveUser } from '../interface/IManageTestUser';

interface IFetchManageTestUsers extends IPaginationParams {
  username?: string;
  fullName?: string;
}

export async function fetchManageTestUsersApiList({
  username,
  fullName,
  ...paginationParams
}: IFetchManageTestUsers): Promise<IManageTestUsersResponse> {
  const params: { [key: string]: string } = {};

  if (username) {
    params.username = username.toString();
  }
  if (fullName) {
    params.fullName = fullName.toString();
  }
  const queryParams = createPaginationParams(paginationParams);

  return fetch(`${getServiceBaseURL(APIServiceEnum.LK_SERVICE)}/admin/users/find-users?${queryParams}`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...params,
    }),
  }).then(handleResponse);
}

export async function fetchUpdateManageTestUsersApiList(list: IActionAboveUser[]): Promise<IManageTestUsersResponse> {
  return fetch(`${getServiceBaseURL(APIServiceEnum.LK_SERVICE)}/admin/users/set-test-users`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ users: list }),
  }).then(handleResponse);
}
